import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectToasts } from '@libs/store/toast/selectors';
import { addToast, removeToast, setShowToast } from '@libs/store/toast/actions';
import { selectModalState } from '@libs/store/modal/selectors';
import { addModal, removeModal } from '@libs/store/modal/actions';
import { IToast } from '@libs/store/toast/model';
import { IModal } from '@libs/store/modal/model';

@Injectable({
  providedIn: 'root',
})
export class StoreToastModalsService {
  constructor(private store: Store) {}

  /**
   * Selects the toasts from the store.
   * @returns An observable of the toasts.
   */
  selectToasts() {
    return this.store.select(selectToasts);
  }

  /**
   * Sets the visibility of a toast.
   * @param {number} id - The ID of the toast.
   * @param {boolean} show - The visibility state of the toast.
   */
  setShowToast(id: number, show: boolean): void {
    this.store.dispatch(setShowToast({ id, show }));
  }

  /**
   * Removes a toast from the store.
   * @param {number} id - The ID of the toast to remove.
   */
  removeToast(id: number): void {
    this.store.dispatch(removeToast({ id }));
  }

  /**
   * Selects the modal state from the store.
   * @returns An observable of the modal state.
   */
  selectModalState() {
    return this.store.select(selectModalState);
  }

  /**
   * Removes a modal from the store.
   */
  removeModal(): void {
    this.store.dispatch(removeModal());
  }

  /**
   * Adds a toast to the store.
   * @param {IToast} toast - The toast to add.
   */
  addToast(toast: IToast) {
    this.store.dispatch(addToast({ toast }));
  }
  addModal(modal: IModal) {
    this.store.dispatch(addModal({ modal }));
  }
}
